import {Injectable, TemplateRef} from '@angular/core';
import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {Message, MessageService} from '@wuitk/angular/components/notification';
import {NotificationMessageTypes} from "@ispm/core/constants/notification-message-types.constant";
import {NotificationMessageButton} from "@ispm/core/interfaces/notification-message-button.interface";

@Injectable()
export class NotificationMessageService {
  public iconType: string;
  public detectChange = true;

  private configTime: number;
  private htmlTemplate: TemplateRef<any> = null;
  private notiMessage: Message;

  constructor(
    private _messageService: MessageService,
    private _http: HttpInterceptorService
  ) {
  }

  public setHtmlTemplate = (htmlTemplate: TemplateRef<any>) => {
    this.htmlTemplate = htmlTemplate;

    this.getGrowlTTL().subscribe(data => {
      this.configTime = data.body.ttl ? data.body.ttl * 1000 : 10000;
    });
  }

  public error = (message: string, time?: number, body?: string, keepNotifications?: boolean, isSticky: boolean = false, buttons: Array<NotificationMessageButton> = []) => {
    this.showMessage(NotificationMessageTypes.ERROR, message, time, body, keepNotifications, isSticky, buttons);
  }

  public success = (message: string, time?: number, body?: string, keepNotifications?: boolean, isSticky: boolean = false, buttons: Array<NotificationMessageButton> = []) => {
    this.showMessage(NotificationMessageTypes.SUCCESS, message, time, body, keepNotifications, isSticky, buttons);
  }

  public warning = (message: string, time?: number, body?: string, keepNotifications?: boolean, isSticky: boolean = false, buttons: Array<NotificationMessageButton> = []) => {
    this.showMessage(NotificationMessageTypes.WARN, message, time, body, keepNotifications, isSticky, buttons);
  }

  public info = (message: string, time?: number, body?: string, keepNotifications?: boolean, isSticky: boolean = false, buttons: Array<NotificationMessageButton> = []) => {
    this.showMessage(NotificationMessageTypes.INFO, message, time, body, keepNotifications, isSticky, buttons);
  }

  public showMessage = (severity: any, message: string, time?: number, body?: string, keepNotifications?: boolean, forceStickiness: boolean = false, buttons: Array<NotificationMessageButton> = []) => {
    if (!keepNotifications && this.notiMessage && JSON.parse(this.notiMessage.data).behavior !== 'sticky') {
      this.closeNotification(this.notiMessage);
    }

    this.iconType = severity;
    const sticky = !(severity === NotificationMessageTypes.INFO || severity === NotificationMessageTypes.SUCCESS || time) || forceStickiness;
    time = time ? time : this.configTime;

    this.notiMessage = {
      severity,
      title: message,
      body: body,
      template: this.htmlTemplate,
      key: 'severity',
      sticky: sticky,
      closable: true,
      life: time,
      classNames: 'notification-width',
      data: JSON.stringify({behavior: forceStickiness ? 'sticky' : 'closable'}),
      buttons: buttons && buttons.length > 0 ? buttons : []
    };

    this._messageService.add(this.notiMessage);
  }

  public closeNotification = (message) => {
    this._messageService.clearMessage(message);
    this.detectChange = true;
  }

  public closeAllNotifications = () => {
    this._messageService.clearAll();
  }

  private getGrowlTTL: any = () => {
    return this._http.get('/growlTTLInSeconds');
  }
}
